import { render, staticRenderFns } from "./modal_contents.vue?vue&type=template&id=249064a2&"
import script from "./modal_contents.vue?vue&type=script&lang=js&"
export * from "./modal_contents.vue?vue&type=script&lang=js&"
import style0 from "./modal_contents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardTitle,VDialog,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('249064a2')) {
      api.createRecord('249064a2', component.options)
    } else {
      api.reload('249064a2', component.options)
    }
    module.hot.accept("./modal_contents.vue?vue&type=template&id=249064a2&", function () {
      api.rerender('249064a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/modal_contents.vue"
export default component.exports